import msAuth from '@moneysmart/auth'

try {
  if (msAuth) {
    msAuth.init({
      locale: process.env.DEFAULT_LOCALE,
      region: process.env.AWS_REGION,
      userPoolId: process.env.AWS_USER_POOL_ID,
      identityPoolId: process.env.AWS_IDENTITY_POOL_ID,
      userPoolWebClientId: process.env.AWS_WEB_CLIENT_ID,
      cookieStorageDomain: process.env.AWS_COOKIE_DOMAIN,
      oauthDomain: process.env.AWS_OAUTH_DOMAIN,
      oauthRedirectSignIn: process.env.AWS_REDIRECT_SIGN_IN,
      oauthRedirectSignOut: process.env.AWS_REDIRECT_SIGN_OUT,
      cookieSecure: process.env.NODE_ENV !== 'development',
      msApiEndpoint: process.env.MS_API_ENDPOINT,
    });

    const sha256 = (str) =>
      crypto.subtle
        .digest('SHA-256', new TextEncoder('utf-8').encode(str))
        .then(h => {
          let hexes = [],
            view = new DataView(h);
          for (let i = 0; i < view.byteLength; i += 4)
            hexes.push(('00000000' + view.getUint32(i).toString(16)).slice(-8));
          return hexes.join('');
        })

    window.msAuth = {
      refreshSessionIfExpiringBefore: msAuth?.refreshSessionIfExpiringBefore,
      currentSession: msAuth?.currentSession,
      sha256
    }
  } else {
    console.warn('msAuth module not properly imported or init method not available');
  }
} catch (error) {
  console.error('Failed to initialize msAuth:', error);
}